angular.module('rjmNg.services').factory('fileUploadService', [
  "$http"
  "$url"
  "$rootScope"
  "app"
  ($http, $url, $rootScope, app) ->
    fileUploadService = {}

    fileUploadService.listFiles = () ->
      $http.get($url("/client/#{app.getClientId()}/fileuploads/"))

    fileUploadService.listTables = () ->
      $http.get($url("/client/#{app.getClientId()}/userpush/"))

    fileUploadService.download = (file) ->
      $http(
        method: 'POST'
        url: $url("/client/#{app.getClientId()}/upload/getTemporaryCredentialsAndUrl")
        data: $.param({internalName: file.internalFileName, fileName: file.name})
        headers: {'Content-type': 'application/x-www-form-urlencoded'}
      ).then( ({data}) ->
        fileUploadService.triggerDownload(data.request)
      )

    fileUploadService.triggerDownload = (url) ->
      document.location = url

    fileUploadService
  ]
)
